var map = {
	"./2023年卫星数据产品验证报告-GF1WFV2.pdf": 2994,
	"./2023年卫星数据产品验证报告-GF6WFV.pdf": 7129,
	"./2023年卫星数据产品验证报告-HJ2BCCD3.pdf": 4360,
	"./2024年卫星数据产品验证报告-GF1WFV1.pdf": 4368,
	"./2024年卫星数据产品验证报告-GF1WFV3.pdf": 4970,
	"./2024年卫星数据产品验证报告-HJ2ACCD1.pdf": 5630,
	"./2024年卫星数据产品验证报告-HJ2ACCD3.pdf": 2708,
	"./2024年卫星数据产品验证报告-HJ2BCCD3.pdf": 3279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6779;